export default {
  heading: {
    subtitle: "Entretien de chaudière à Toulouse",
    icons: [
      {
        src: "/img/icons/approve-invoic-bicolor-light.png",
        alt: "Icone devis",
      },
      {
        src: "/img/icons/calendar-bicolor-light.png",
        alt: "Icone calendrier",
      },
      {
        src: "/img/icons/piggy-bank-bicolor-light.png",
        alt: "Icone tarifs",
      },
    ],
    items: [
      " Entretien à 85 € TTC",
      " Un rendez-vous dans la semaine",
      " Déplacement inclus",
    ],
  },
  section1: {
    title: "Pour votre sécurité et vos économies :",
    text:
      "Une chaudière bien entretenue c'est 5 fois moins de pannes, une espérance de vie multipliée par 2 💪 et des économies substancielles sur votre facture énergétique.<br/> Cela permet surtout de prévenir tout risque d'intoxication au mooxyde de carbone. Pour cette raison, l'entretien annuel par un chauffagiste est une obligation légale depuis le décret n° 2009-649 du 9 juin 2009. Un entretien correctement mené doit en outre être suivi par des conseils sur le bon usage de la chaudière en place ainsi que les améliorations possibles sur l'ensemble de l'installation.",
    ctaText: "Pour planifier un entretien, appelez nous au :",
  },
  section2: {
    steps1: [
      "Contrôler tous les organes de sécurité",
      "Vérifier l'étanchéité gaz et eau",
      "Nettoyer le corps de chauffe, le brûleur et la veilleuse",
      "Vérifier le fonctionnement des brûleurs",
      "Vérifier le débit du gaz et le régler si nécessaire",
      "Contrôler le taux de monoxyde de carbone",
    ],
    text1:
      "Un bon chauffagiste doit aussi vous conseiller sur le bon usage de la chaudière en place, les améliorations possibles de l'ensemble de l'installation.",
    text2:
      "Selon l'état de votre appareil, l'entretien peut durer entre 30min et 1h.",

    text3:
      "Nous vous proposons l'entretien de votre chaudière au prix de 85 € TTC. Il comprend :",
    steps3: [
      "1 visite d’entretien par an",
      "Le nettoyage et le contrôle de votre appareil",
      "La main d'oeuvre",
      "Le déplacement",
    ],
    ctaText: "Prenez RDV dès aujourd'hui.",
    ctaTextMobile:
      'Appelez-nous et planifiez <br />votre entretien dans <span class="no-wrap"> la semaine !</span>',
  },
  aside: {
    img: {
      src: "/img/pages/page-content_team.jpg",
      alt: "Entretien chaudière",
    },
    ctaText: "C'est le moment de procéder à l'entretien de votre chaudière ?",
    quoteRequest: {
      recipient: "contact+devisEntretien",
      body:
        "Bonjour,%0D%0A %0D%0A J'aimerais réaliser l'entretien de ma chaudière %0D%0A %0D%0A - Marque/Modèle : %0D%0A - Délai : %0D%0A - Code postal : %0D%0A - Ville : %0D%0A - Nom : %0D%0A - Numéro de téléphone (optionnel) : %0D%0A %0D%0A Bien à vous",
    },
  },
};
